//#region header */
/**************************************************************************************************
//
//  Description: Error display control
//
//  Copyright:    © 2025 - 2026 Idox Software Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//#region Version 1.0.0.0 changes
//    001   21.02.25 Sean Flook          GMSCM-1 Initial Revision.
//    002   05.02.26 Sean Flook         GMSCM-12 Added ability to handle string arrays as well as not displaying the label spacer.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */

import React, { Fragment, useEffect, useState } from "react";

import { Grid2, Stack, Typography } from "@mui/material";

import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

import { adsRed } from "../utils/ADSColour";

interface ADSErrorDisplayProps {
  errorText: string | string[] | undefined;
  id: string;
  removeLabelSpacer?: boolean;
}

const ADSErrorDisplay: React.FC<ADSErrorDisplayProps> = ({ errorText, id, removeLabelSpacer = false }) => {
  const [errorString, setErrorString] = useState<string>("");

  useEffect(() => {
    setErrorString(Array.isArray(errorText) ? errorText.join(", ") : errorText || "");
  }, [errorText]);

  return errorString && errorString.length > 0 ? (
    removeLabelSpacer ? (
      <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={0.25} sx={{ pl: "4px" }}>
        <PriorityHighIcon sx={{ color: adsRed, height: "16px", width: "16px" }} />
        <Stack direction="column">
          {errorString.split(", ").map((rec, idx) => (
            <Typography
              id={`${id}-${idx}`}
              variant="caption"
              align="left"
              key={`error-${id}-${idx}`}
              sx={{ fontWeight: 600, color: adsRed }}
            >
              {`${rec.replace("¬", ",")}`}
            </Typography>
          ))}
        </Stack>
      </Stack>
    ) : (
      <Fragment>
        <Grid2 size={3} />
        <Grid2 size={9}>
          <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={0.25} sx={{ pl: "4px" }}>
            <PriorityHighIcon sx={{ color: adsRed, height: "16px", width: "16px" }} />
            <Stack direction="column">
              {errorString.split(", ").map((rec, idx) => (
                <Typography
                  id={`${id}-${idx}`}
                  variant="caption"
                  align="left"
                  key={`error-${id}-${idx}`}
                  sx={{ fontWeight: 600, color: adsRed }}
                >
                  {`${rec.replace("¬", ",")}`}
                </Typography>
              ))}
            </Stack>
          </Stack>
        </Grid2>
      </Fragment>
    )
  ) : (
    <></>
  );
};

export default ADSErrorDisplay;
